 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {ReactRenderer} from '@tiptap/react'


import tippy, {} from 'tippy.js'

const renderSuggestion =
  (Component) =>
  () => {
    
    let component
    let popup

    return {
      onStart: (props) => {
        component = new ReactRenderer(Component, {
          props,
          editor: props.editor
        })
        if (!props.clientRect) return
        popup = tippy(document.body, {
          animation: false,
          getReferenceClientRect: props.clientRect ,
          appendTo: () => document.body,
          content: component.element,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start'
        })
      },

      onUpdate(props) {
        _optionalChain([component, 'optionalAccess', _ => _.updateProps, 'call', _2 => _2(props)])
        if (!props.clientRect) return
        _optionalChain([popup, 'optionalAccess', _3 => _3.setProps, 'call', _4 => _4({
          getReferenceClientRect: props.clientRect 
        })])
      },

      onKeyDown(props) {
        if (props.event.key === 'Escape') {
          _optionalChain([popup, 'optionalAccess', _5 => _5.hide, 'call', _6 => _6()])
          return true
        }
        return _optionalChain([component, 'optionalAccess', _7 => _7.ref, 'optionalAccess', _8 => _8.onKeyDown, 'call', _9 => _9(props)])
      },

      onExit() {
        _optionalChain([popup, 'optionalAccess', _10 => _10.destroy, 'call', _11 => _11()])
        _optionalChain([component, 'optionalAccess', _12 => _12.destroy, 'call', _13 => _13()])
      }
    }
  }

export default renderSuggestion
